import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import Calendar from 'react-calendar';
import { blue500, cyan500, grey100, cyan100, grey800 } from 'material-ui/styles/colors';
import { areDateEquals } from 'src/utils/dates';
import 'src/css/calendar.css';
import TaskTimeItemDialog from 'src/components/TaskTimeItemDialog';
import { parseNumber } from 'src/utils/parsing';
var styles = {
    customTile: {
        borderRadius: 3,
        backgroundColor: cyan100,
        color: 'black',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};
var DurationTile = function (_a) {
    var duration = _a.duration, tileStyle = _a.tileStyle, isToday = _a.isToday, _b = _a.tooltip, tooltip = _b === void 0 ? null : _b;
    var style = tslib_1.__assign({}, tileStyle, { border: isToday
            ? "1px solid " + blue500
            : 'none' });
    if (tooltip) {
        style.borderLeft = '5px solid red';
    }
    return (React.createElement("div", { style: style, title: tooltip }, duration));
};
var TaskTimeItemCalendar = /** @class */ (function (_super) {
    tslib_1.__extends(TaskTimeItemCalendar, _super);
    function TaskTimeItemCalendar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            day: new Date(),
            timeRegistrationDialogOpened: false
        };
        _this.handleDayClick = function (day) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setState({
                    day: day,
                    timeRegistrationDialogOpened: true
                });
                return [2 /*return*/];
            });
        }); };
        _this.registerWorkTime = function (data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, this.props.task.setTimeOn(this.state.day, parseNumber(data.hours), data.note)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        this.setState({ timeRegistrationDialogOpened: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.cancelWorkTimeRegistration = function () {
            _this.setState({ timeRegistrationDialogOpened: false });
        };
        _this.tileContent = function (_a) {
            var date = _a.date, view = _a.view;
            if (view !== 'month') {
                return null;
            }
            var duration = _this.props.task.times.timeSpentOn(date);
            var style = tslib_1.__assign({}, styles.customTile);
            if (duration > 0) {
                style.backgroundColor = cyan500;
                style.color = 'white';
            }
            if (date < _this.minDate || date > _this.maxDate) {
                style.backgroundColor = grey100;
                style.color = grey800;
            }
            var isToday = areDateEquals(date, new Date());
            return React.createElement(DurationTile, { isToday: isToday, tooltip: _this.props.task.times.notesOn(date), duration: duration > 0 ? (React.createElement("span", null,
                    duration,
                    " ",
                    React.createElement("small", null, "\u00F3ra"))) : null, tileStyle: style });
        };
        return _this;
    }
    Object.defineProperty(TaskTimeItemCalendar.prototype, "minDate", {
        get: function () {
            var dateString = this.props.projectStore.configuration.currentSprint.start;
            return new Date(dateString);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskTimeItemCalendar.prototype, "maxDate", {
        get: function () {
            var dateString = this.props.projectStore.configuration.currentSprint.end;
            return new Date(dateString);
        },
        enumerable: true,
        configurable: true
    });
    TaskTimeItemCalendar.prototype.render = function () {
        var task = this.props.task;
        var timeRegistrationDialog = !this.state.timeRegistrationDialogOpened ? null : (React.createElement(TaskTimeItemDialog, { initialHours: this.props.task.times.timeSpentOn(this.state.day), initialNotes: this.props.task.times.notesOn(this.state.day), onSubmit: this.registerWorkTime, onCancel: this.cancelWorkTimeRegistration }));
        return (React.createElement(React.Fragment, null,
            React.createElement(Calendar, { locale: "hu-HU", className: "task-time-calendar", tileContent: this.tileContent, onClickDay: task.isReadonly ? null : this.handleDayClick, maxDetail: "month", minDetail: "month" }),
            timeRegistrationDialog));
    };
    TaskTimeItemCalendar = tslib_1.__decorate([
        inject('projectStore'),
        observer
    ], TaskTimeItemCalendar);
    return TaskTimeItemCalendar;
}(React.Component));
export default TaskTimeItemCalendar;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskTimeItemCalendar.tsx
// module id = 751
// module chunks = 0